module.exports = ".disabled-link {\n  pointer-events: none;\n  text-decoration: none;\n  opacity: 0.5;\n}"